/**
 * Sessione del login finto (VITE_MOCK_AUTH=true). Sta qui e non in AuthService
 * perche' serve anche a plugins/axios.js, che non puo' importare AuthService.
 */
const KEY = 'kris-agent:mock-session'

export function readMockSession() {
  try {
    return JSON.parse(localStorage.getItem(KEY))
  } catch {
    return null
  }
}

export function writeMockSession(user) {
  localStorage.setItem(KEY, JSON.stringify(user))
}

export function clearMockSession() {
  localStorage.removeItem(KEY)
}

/** Token accettato dall'API locale con AUTH_MOCK_ENABLED=true. */
export function mockToken() {
  const session = readMockSession()
  if (!session) return null
  return `mock:${session.id}:${session.roles.join(',')}`
}
